import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {SharedService} from '../../../core/services/store/shared-store/shared-storage.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Route} from '../../../shared/models';


interface TokenResponse {
    route: Route;
    routeId: string;
    entityId: bigint;
    entityType: string;
    apiToken: string;
}

@Injectable()
export class RouteApiTokenService {

    private static readonly baseApiUriV3: string = environment.controlBaseUrl + environment.flowManagerBaseUri + '/v3';


    constructor(private httpClient: HttpClient,
                private sharedService: SharedService) {}

    generateToken(routeId: string): Observable<TokenResponse> {
        return this.httpClient.get<TokenResponse>(this.createEntityUriV3(['jwt', 'generate', routeId]));
    }

    getRouteApiToken(routeId: string) {
        return this.httpClient.get<TokenResponse>(this.createEntityUriV3(['jwt', routeId]))
            .pipe(map(value => value.apiToken));
    }


    private createEntityUriV3(paths: string[]) {
        let finalUrl = RouteApiTokenService.baseApiUriV3;
        const baseUri = [
            this.sharedService.getEnvironment(),
            this.sharedService.getEntityType(),
            this.sharedService.getEntityId()
        ];
        const newPath = baseUri.concat(paths);

        newPath.forEach((path) => {
            finalUrl = finalUrl.concat('/').concat(path);
        });
        return finalUrl;
    }
}
